<template>
    <div>
        <label
            v-if="label.length > 0"
            class="form-label"
            :for="id"
        >{{ label }}</label>
        <date-picker
            :id="id"
            :input-attr="{ id: id }"
            :value="date"
            :placeholder="dateFormat"
            :formatter="momentFormat"
            :disabled-date="isBefore"
            :disabled="disabled"
            :input-class="{'mx-input': true, 'error': isValid === false, 'gray': isGray, haveClass : haveClass.length > 0 }"
            @update:value="emitDate"
        />
        <div
            v-if="invalidFeedback"
            class="invalid-feedback d-block"
        >
            {{ invalidFeedback }}
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import moment from 'moment'

export default {
    name: 'DDateFormatInput',
    components: {
        DatePicker
    },
    props: {
        modelValue: {
            type: String,
            default: () => null
        },
        format: {
            type: String,
            required: false,
            default: () => 'DD.MM.YYYY'
        },
        isValid: {
            type: Boolean,
            default: () => true
        },
        isGray: {
            type: Boolean,
            default: () => false
        },
        haveClass: {
            type: String,
            default: () => ''
        },
        label: {
            type: String,
            default: () => ''
        },
        id: {
            type: String,
            default: () => 'datepicker'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        invalidFeedback: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue', 'valueChanged'],
    data () {
        return {
            minDate: new Date('1900-01-01'),
            maxDate: new Date('2050-01-01'),
            dateFormat: this.format,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format(this.format) : ''
                },
                parse: (value) => {
                    return value ? moment(value, this.format).toDate() : null
                }
            }
        }
    },
    computed: {
        date () {
            return this.modelValue ? moment(this.modelValue).toDate() : null
        }
    },
    methods: {
        emitDate (value) {
            const formattedDate = moment(value).format('YYYY-MM-DD')

            this.$emit('update:modelValue', value === null ? value : formattedDate)
            this.$emit('valueChanged')
        },
        isBefore (date) {
            return date.getTime() < this.minDate.getTime() || date.getTime() > this.maxDate
        }
    }
}
</script>
<style lang="scss">
.mx-datepicker-popup {
    z-index: 5000;
}

.mx-datepicker {
    width: 100%;
    &::placeholder {
        width: 100%;
    }
    .mx-input, input {
        border-color: var(--colorAppBorder)!important;
        width: 100%;
        box-shadow: none;

        &[disabled] {
            background-color: #e4e7ea;
            border: 1px solid #e4e7ea;
            color: #5c6873;
        }
    }
}
.error.mx-input {
    border-color: var(--colorBorderError)!important;
    width: 100%;
}
.gray.mx-input {
    background-color: var(--light-legacy-theme)!important;
}

</style>
